import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import styled from 'styled-components'

import BackgroundImage from 'gatsby-background-image'

const HoldingHandsSection = ({ className, children }) => (
    <StaticQuery
        query={graphql`
            {   holdingHands: file(relativePath:{eq:"holding-hands-banner.jpg"}) {
            childImageSharp {
              fluid(quality:90, maxWidth:1920) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        `}
    render={data => {
        const imageData = data.holdingHands.childImageSharp.fluid
    
    return (
    <BackgroundImage
        tag="section"
        className={className}
        fluid={imageData}
        backgroundColor={`#000000`}
    >
        { children }
    </BackgroundImage>
    )
}}
/>
)

const StyledBackgroundSection = styled(HoldingHandsSection)`
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
`

export default StyledBackgroundSection